/*
 * From https://www.redblobgames.com/x/2208-bookmark-search/
 * Copyright 2022 Red Blob Games <redblobgames@gmail.com>
 * License: Apache-2.0 <http://www.apache.org/licenses/LICENSE-2.0.html>
 */

console.info("I'm happy to answer questions about the code; email me at redblobgames@gmail.com");

let inputBox = document.querySelector(".search input") as HTMLInputElement;
let outputBox = document.querySelector(".search output");

let bookmarks = [];

function htmlEscape(rawString) {
    return rawString
        .replace(/&/g, "&amp;").replace(/"/g, "&quot;")
        .replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

async function get_results(q) {
    let response = await fetch(`./query?q=${encodeURIComponent(q)}`, {mode: 'no-cors'});
    if (!response.ok) { throw new Error(`HTTP error! status: ${response.status}`); }
    let json = await response.json();
    return json;
}

async function get_results_local(q) {
    const MAX_RESULT_COUNT = 20;
    if (bookmarks.length === 0) {
        let response = await fetch("pinboard.json");
        bookmarks = await response.json();
        bookmarks = bookmarks.filter(b => b.shared === 'yes');
    }

    function RegexpEscape(s) {
        // polyfill for failed proposal https://github.com/tc39/proposal-regex-escaping/
        return String(s).replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    
    let results = []; // [[score, bookmark], ...]
    let matchPatterns = [
        [2, new RegExp('\\A' + RegexpEscape(q), 'ig')],
        [1, new RegExp('\\b' + RegexpEscape(q), 'ig')],
        [1, new RegExp(        RegexpEscape(q), 'ig')],
    ];
    // TODO: for tags, I should not \A
    // TODO: should split into words but also give a bonus for adjacency

    function matchScore(bookmark) {
        let score = 0;
        for (let [multiplier1, part] of [
            [5, bookmark.tags],
            [3, bookmark.description],
            [1, bookmark.extended],
            [1, bookmark.href],
        ]) {
            for (let [multiplier2, pattern] of matchPatterns) {
                score += multiplier1 * multiplier2 * Array.from(part.matchAll(pattern)).length;
            }
        }
        return score;
    }

    for (let bookmark of bookmarks) {
        let score = matchScore(bookmark);
        if (score > 0) {
            // console.log(`    ${q} --> ${score} ${bookmark.description}`);
            results.push([score, bookmark]);
        }
    }

    console.log(`query ${q}: ${results.length}/${bookmarks.length} bookmarks matched`);
    if (q !== "") results.sort((a, b) => b[0] - a[0]);

    return results.slice(0, MAX_RESULT_COUNT);
}

async function query() {
    let q = inputBox.value;
    let results = await get_results_local(q);
    if (inputBox.value !== q) {
        // it has changed since we sent out for results, so ignore the response
        return;
    }
    setOutput(results);
}

function setOutput(results) {
    let bookmarks = results.map(result => result[1]);
    let html = `<div>`;
    for (let bookmark of bookmarks) {
        html += `<div>
<b><a target=_blank href="${htmlEscape(bookmark.href)}">${htmlEscape(bookmark.description) ?? "(link)"}</a></b>
<div style="color:hsl(120,50%,30%);font-size:70%">${htmlEscape(bookmark.href)}</div>
<div style="font-size:70%">${htmlEscape(bookmark.extended)}</div>
<div style="color:hsl(250,10%,50%);font-size:70%">${htmlEscape(bookmark.time)}</div>
<div style="color:hsl(200,50%,30%);font-size:80%">${htmlEscape(bookmark.tags)}</div>
</div>`;
    }
    html += `</div>`;
    outputBox.innerHTML = html;
}


inputBox.addEventListener('input', query);
inputBox.focus();
query();

